<ul class="pagination">
  <ng-container *ngFor="let pageNum of getPages()">
    <li (click)="onPage(pageNum)" class="page-item active" *ngIf="pageNum === (page)">
      <a class="page-link ">{{pageNum}}</a>
    </li>
    <li (click)="onPage(pageNum)" class="page-item" *ngIf="!(pageNum === (page))">
      <a class="page-link">{{pageNum}}</a>
    </li>
  </ng-container>
</ul>
